import React from 'react'

// prettier-ignore
export const EquipmentVistaItem = {
  Edit: React.lazy(() => import('./edit')),
}
